<div class="body fade-in" [ngClass]="getBodyClass()">
  <router-outlet></router-outlet>
</div>